module.exports = __webpack_public_path__ + "img/chrome2.0574f5ee.png";